module.exports = "<p>usc-bi-component loaded</p>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-bi/usc-bi.component.html
// module id = ../../../../../src/app/components/usc-bi/usc-bi.component.html
// module chunks = main